import React from 'react'

import { DropdownMenu } from '../DropdownMenu/DropdownMenu'

import { sendTealiumClickEvent, ClickEventOptions } from '../../utils/sendTealiumEvent'

type Link = {
  id: string;
  label: string;
  href: string;
}

interface NavSectionProps {
  analyticsCategory: string;
  description?: string;
  isLoggedIn: boolean;
  label: string;
  links: Link[];
  menuName: string;
}

const NavSection: React.FC<NavSectionProps> = ({ description, isLoggedIn, label, links, menuName, analyticsCategory }) => {
  const sendClickEvent = (link: Link) => {
    const options: ClickEventOptions = {
      text: link.label,
      logged_in: isLoggedIn,
      target_location: link.href,
      subheading: label,
      heading: menuName,
      category: analyticsCategory
    }

    sendTealiumClickEvent(options)
  }

  return (
    <li className='ch-c-resource-dropdown__link-section ds-u-sans'>
      <h2 className='ch-c-resource-dropdown__section-label'>{label}</h2>
      {
        description && <div className='ch-c-resource-dropdown__section-description ds-text-lead'>{description}</div>
      }
      <ul className='ch-c-resource-dropdown__link-list'>
        {links.map(link => (
          <li key={link.id}>
            <a className='ch-c-link ds-u-color--primary ch-u-text-decoration-none ch-u-text-hover-underline' href={link.href} onClick={() => sendClickEvent(link)}>{link.label}</a>
          </li>)
        )}
      </ul>
    </li>
  )
}

export interface ResourceNavDropdownProps {
  analyticsCategory: string;
  isLoggedIn: boolean;
  name: string;
  sections: any[];
}

export const ResourceNavDropdown: React.FC<ResourceNavDropdownProps> = ({ analyticsCategory, isLoggedIn, name, sections }) => {
  return (
    <DropdownMenu className='ch-c-resource-dropdown'>
      <ul className='ch-c-resource-dropdown ch-c-resource-dropdown_508_padding ch-u-list-style-type--none'>
        {sections.map(section => (
          <NavSection
            analyticsCategory={analyticsCategory}
            key={section.id}
            menuName={name}
            isLoggedIn={isLoggedIn}
            description={section.description}
            label={section.label}
            links={section.links}
          />))}
      </ul>
    </DropdownMenu>
  )
}
